var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 367.251,
    height: 417.44,
    viewBox: "0 0 367.251 417.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-129.55 -345.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(130 346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.3,322.547c-.007-8.63.265-17.279-.185-25.888C325.556,286,320.242,281.01,309.665,281q-64.639-.054-129.286-.061-61.847.009-123.693.061c-10.577.007-15.891,5-16.449,15.656-.449,8.609-.179,17.258-.185,25.888-.013,22.9,0,25.392-18,25.39-2.2,0-4.671-.037-7.442-.078-12.964-.194-16.2-3.946-13.944-16.339,1.85-10.165,4.528-20.24,5.581-30.483,2.818-27.445,16.208-46.408,41.53-58.122q3.042-1.407,6.026-2.94c7.332-4.362,14.772-8.56,22.222-12.744,5.5-3.359,10.981-6.751,16.539-9.98,13.3-7.729,14.73-11.973,7.381-25.856-5.3-10.019-11.364-19.639-17.116-29.418-6.823-11.6-7.75-23.936-4.99-36.871C86.894,82.621,108.2,47.3,139.722,17.7,152.252,5.929,167.748-.063,183.2,0c15.437-.052,30.91,5.94,43.429,17.7,31.518,29.6,52.828,64.923,61.889,107.409,2.76,12.934,1.833,25.271-4.99,36.87-5.753,9.779-11.813,19.4-17.116,29.418-7.349,13.883-5.917,18.129,7.381,25.856,5.556,3.228,11.036,6.62,16.533,9.977,7.452,4.185,14.894,8.384,22.227,12.747q2.987,1.528,6.027,2.94c25.321,11.716,38.712,30.677,41.53,58.122,1.052,10.245,3.731,20.318,5.581,30.483,2.254,12.395-.981,16.145-13.946,16.339-2.771.041-5.242.078-7.442.078C326.3,347.939,326.311,345.444,326.3,322.547Z",
    transform: "translate(0 0)",
    fill: "#15133c",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(181.798 678.214)",
    fill: "#100c36",
    fontSize: 51,
    fontFamily: "Heavitas"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CERAMIC")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(181.798 744.94)",
    fill: "#170095",
    fontSize: 73,
    fontFamily: "Heavitas"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FRAUD")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(266.747 472.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.279,382.086c6.5,28.112,22.054,43.291,46.088,43.635,24.961.361,38.791-12.672,47.327-43.811-10.3-2.329-22.406-2.039-30.472-7.606-12.083-8.337-20.255-8.458-32.355-.145C296.9,379.633,285.092,379.523,274.279,382.086Z",
    transform: "translate(-274.279 -352.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.712,366.293q10.557,2.5,21.119,5l.854-3.47c-5.882-6.417-12.84-9.011-21.206-6.605Q304.1,363.755,303.712,366.293Z",
    transform: "translate(-303.712 -360.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.685,366.293q-10.557,2.5-21.119,5l-.854-3.471c5.882-6.417,12.84-9.011,21.206-6.605Q325.3,363.755,325.685,366.293Z",
    transform: "translate(-245.698 -360.334)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.719507fda36c1fcec8470dcecce114e3.svg";
export { ForwardRef as ReactComponent };